








































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const tagManager = namespace("tagManager");
@Component({})
export default class storeSelect extends Vue {
  dialogVisible: boolean = false;
  storeList: any = [];
  @tagManager.State storeListData;
  @Prop() editData: any;
  @Watch("editData")
  onEditDataChange(val) {
    this.storeList = val || [];
  }
  handleConfirm() {
    let data = this.storeListData.filter(i =>
      this.storeList.includes(i.storeCode)
    );
    this.$emit("on-select", data);
    this.storeList = [];
    this.dialogVisible = false;
  }
}
